function remove() {
  var parent = this.parentNode;
  if (parent) parent.removeChild(this);
}

export default function() {
  return this.each(remove);
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-selection/src/selection/remove.js
// module id = RsqV
// module chunks = 0